<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('animales')">Animales</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Agregar
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- Identificación -->
          <text-input
            v-model="form.codigo"
            :error="form.errors.codigo"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Código"
          />

          <text-input
            v-model="form.arete"
            :error="form.errors.arete"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Arete"
          />

          <text-input
            v-model="form.nombre"
            :error="form.errors.nombre"
            class="pr-6 pb-8 w-full lg:w-2/4"
            label="Nombre"
            required
          />

          <!-- Especie / Raza -->
          <select-input
            v-model="form.especie_id"
            :error="form.errors.especie_id"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Especie"
            required
          >
            <option :value="null" disabled>Seleccione una especie</option>
            <option v-for="e in especies" :key="e.id" :value="e.id">
              {{ e.nombre }}
            </option>
          </select-input>

          <select-input
            v-model="form.raza_id"
            :error="form.errors.raza_id"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Raza"
          >
            <option :value="null">Sin raza</option>
            <option v-for="r in razas" :key="r.id" :value="r.id">
              {{ r.nombre }}
            </option>
          </select-input>

          <!-- Datos generales -->
          <select-input
            v-model="form.sexo"
            :error="form.errors.sexo"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Sexo"
            required
          >
            <option :value="null" disabled>Seleccione</option>
            <option value="macho">Macho</option>
            <option value="hembra">Hembra</option>
          </select-input>

          <text-input
            v-model="form.fecha_nacimiento"
            :error="form.errors.fecha_nacimiento"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Fecha de Nacimiento"
            type="date"
          />

          <text-input
            v-model="form.peso"
            :error="form.errors.peso"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Peso (kg)"
            type="number"
          />

          <text-input
            v-model="form.color"
            :error="form.errors.color"
            class="pr-6 pb-8 w-full lg:w-1/4"
            label="Color"
          />

          <text-input
            v-model="form.estado_reproductivo"
            :error="form.errors.estado_reproductivo"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Estado Reproductivo"
            placeholder="Ej: Preñada, Vacía, Reproductor..."
          />

          <select-input
            v-model="form.estado"
            :error="form.errors.estado"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Estado"
            required
          >
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
            <option value="Vendido">Vendido</option>
            <option value="Fallecido">Fallecido</option>
          </select-input>

          <!-- Observaciones -->
          <text-input
            v-model="form.observaciones"
            :error="form.errors.observaciones"
            class="pr-6 pb-8 w-full"
            label="Observaciones"
          />
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Agregar Animal
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Add Animal' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    especies: Array,
    razas: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        codigo: null,
        nombre: null,
        arete: null,

        especie_id: null,
        raza_id: null,

        sexo: null,
        fecha_nacimiento: null,
        peso: null,
        color: null,

        estado_reproductivo: null,
        estado: 'Activo',

        observaciones: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('animales.store'))
    },
  },
}
</script>